import { useIsFeatureEnabled } from '@shared/core/featureFlags';

/**
 * Holiday season in the category nav: `printGalleryHolidayLightsEnabled` turns on the twinkle lights.
 * Holiday Cards leads the nav regardless of the flag (see `putHolidayFirst`).
 */
export const useIsHolidaySeason = () => {
  const [isHolidaySeason] = useIsFeatureEnabled('printGalleryHolidayLightsEnabled');
  return isHolidaySeason;
};

/**
 * Moves the holiday item to the front, keeping everything else in order. The mega nav, its placeholder
 * and the flat bar all order through this, so the placeholder-to-nav swap can't shift the bar. It's not
 * gated on the flag, so the bar doesn't reorder when the flag loads. Remove it after the holiday season.
 */
export const putHolidayFirst = <T>(items: ReadonlyArray<T>, isHoliday: (item: T) => boolean): T[] => [...items.filter(isHoliday), ...items.filter(item => !isHoliday(item))];
